// Compass pedestal direction arrows (tile 53).

import { G, rooms } from './state';
import { PLAYERW, PLAYERH, TILE, S } from './constants';
import { CanGetArtifact } from './boss';
import { PlayerDir } from './demon';

const M_PI = Math.PI;
const tr = Math.trunc;

function sqr(x: number): number {
  return x * x;
}

function dist(x1: number, y1: number, x2: number, y2: number): number {
  return tr(Math.sqrt(sqr(x2 - x1) + sqr(y2 - y1)));
}

export type CompassDirs = {
  pdir_1: number;
  pdir_2: number;
  pdir_1t: 0 | 1;
  pdir_2t: 0 | 1;
};

type DrawCircleFn = (x: number, y: number, r: number, c: number) => void;
type DrawCircleExFn = (x: number, y: number, r: number, r2: number, c: number) => void;

export function computeCompassDirections(): CompassDirs | null {
  let nearest = 1000000;
  let n_room = -1;
  let bosses_defeated = G.current_boss;
  let pdir_1 = 0;
  let pdir_2 = 0;
  let pdir_1t: 0 | 1 = 0;
  let pdir_2t: 0 | 1 = 0;
  let loc_x = 0;
  let loc_y = 0;

  const rplx = G.player_x + PLAYERW / 2;
  const rply = G.player_y + PLAYERH / 2;

  if (G.current_boss < 3) {
    for (let i = 0; i < 3; i++) {
      if (G.artifacts[8 + i] === 0) {
        if (rooms[i * 1000 + 999].room_type === 2) {
          if (CanGetArtifact()) {
            loc_x = rooms[i * 1000 + 499].x * TILE + rooms[i * 1000 + 499].w * S(16);
            loc_y = rooms[i * 1000 + 499].y * TILE + rooms[i * 1000 + 499].h * S(16);
            const cdist = dist(rplx, rply, loc_x, loc_y);
            if (cdist < nearest) {
              nearest = cdist;
              n_room = i * 1000 + 499;
            }
          }
        }
      } else {
        if (rooms[i * 1000 + 999].room_type === 2) {
          loc_x = rooms[i * 1000 + 999].x * TILE + rooms[i * 1000 + 999].w * S(16);
          loc_y = rooms[i * 1000 + 999].y * TILE + rooms[i * 1000 + 999].h * S(16);
          const cdist = dist(rplx, rply, loc_x, loc_y);
          if (cdist < nearest) {
            nearest = cdist;
            n_room = i * 1000 + 999;
          }
        } else {
          bosses_defeated++;
        }
      }
    }
  }
  if (bosses_defeated === 3) {
    if (G.artifacts[11] === 1) {
      loc_x = rooms[0].x * TILE + rooms[0].w * S(16);
      loc_y = rooms[0].y * TILE + rooms[0].h * S(16);
      const cdist = dist(rplx, rply, loc_x, loc_y);
      if (cdist < nearest) {
        nearest = cdist;
        n_room = 0;
      }
    } else if (CanGetArtifact()) {
      loc_x = rooms[G.place_of_power].x * TILE + rooms[G.place_of_power].w * S(16);
      loc_y = rooms[G.place_of_power].y * TILE + rooms[G.place_of_power].h * S(16);
      const cdist = dist(rplx, rply, loc_x, loc_y);
      if (cdist < nearest) {
        nearest = cdist;
        n_room = G.place_of_power;
      }
    }
  }

  if (n_room !== -1) {
    loc_x = rooms[n_room].x * TILE + rooms[n_room].w * S(16);
    loc_y = rooms[n_room].y * TILE + rooms[n_room].h * S(16);
    pdir_1 = PlayerDir(loc_x, loc_y) + M_PI;
    pdir_1t = 1;
    n_room = -1;
  }

  nearest = 1000000;
  for (let i = 0; i < 3000; i++) {
    if (rooms[i].room_type === 3) {
      loc_x = rooms[i].x * TILE + rooms[i].w * S(16);
      loc_y = rooms[i].y * TILE + rooms[i].h * S(16);
      const cdist = dist(rplx, rply, loc_x, loc_y);
      if (cdist < nearest) {
        nearest = cdist;
        n_room = i;
      }
    }
  }

  if (n_room !== -1) {
    loc_x = rooms[n_room].x * TILE + rooms[n_room].w * S(16);
    loc_y = rooms[n_room].y * TILE + rooms[n_room].h * S(16);
    pdir_2 = PlayerDir(loc_x, loc_y) + M_PI;
    pdir_2t = 1;
  }

  if (!(pdir_1t || pdir_2t)) return null;
  return { pdir_1, pdir_2, pdir_1t, pdir_2t };
}

export function drawCompassOverlay(
  screenX: number,
  screenY: number,
  dirs: CompassDirs,
  drawCircle: DrawCircleFn,
  drawCircleEx: DrawCircleExFn
): void {
  const { pdir_1, pdir_2, pdir_1t, pdir_2t } = dirs;

  drawCircleEx(screenX, screenY, S(200), S(190), 255);
  if (pdir_1t) {
    drawCircleEx(
      screenX + Math.cos(pdir_1) * S(170),
      screenY + Math.sin(pdir_1) * S(170),
      S(30),
      S(20),
      255
    );
  }
  if (pdir_2t) {
    drawCircleEx(
      screenX + Math.cos(pdir_2) * S(170),
      screenY + Math.sin(pdir_2) * S(170),
      S(30),
      S(20),
      195
    );
  }
  for (let i = 0; i < 50; i++) {
    if (pdir_1t) {
      drawCircle(
        screenX + Math.cos(pdir_1) * S(25 + i * 4),
        screenY + Math.sin(pdir_1) * S(25 + i * 4),
        S(5),
        255
      );
    }
    if (pdir_2t) {
      drawCircle(
        screenX + Math.cos(pdir_2) * S(25 + i * 4),
        screenY + Math.sin(pdir_2) * S(25 + i * 4),
        S(5),
        195
      );
    }
  }
  drawCircleEx(screenX, screenY, S(30), S(20), 255);

  drawCircleEx(screenX, screenY, S(197), S(193), 128);
  if (pdir_1t) {
    drawCircleEx(
      screenX + Math.cos(pdir_1) * S(170),
      screenY + Math.sin(pdir_1) * S(170),
      S(27),
      S(23),
      128
    );
  }
  if (pdir_2t) {
    drawCircleEx(
      screenX + Math.cos(pdir_2) * S(170),
      screenY + Math.sin(pdir_2) * S(170),
      S(27),
      S(23),
      78
    );
  }
  for (let i = 0; i < 50; i++) {
    if (pdir_1t) {
      drawCircle(
        screenX + Math.cos(pdir_1) * S(25 + i * 4),
        screenY + Math.sin(pdir_1) * S(25 + i * 4),
        S(3),
        128
      );
    }
    if (pdir_2t) {
      drawCircle(
        screenX + Math.cos(pdir_2) * S(25 + i * 4),
        screenY + Math.sin(pdir_2) * S(25 + i * 4),
        S(3),
        78
      );
    }
  }
  drawCircleEx(screenX, screenY, S(27), S(23), 128);
}

export function drawCompassAtPlayer(
  drawCircle: DrawCircleFn,
  drawCircleEx: DrawCircleExFn
): void {
  const dirs = computeCompassDirections();
  if (!dirs) return;
  const screenX = G.player_x + PLAYERW / 2 - G.scroll_x;
  const screenY = G.player_y + PLAYERH / 2 - G.scroll_y;
  drawCompassOverlay(screenX, screenY, dirs, drawCircle, drawCircleEx);
}
